import { useState } from "react";
import { BookOpenText, FilePdf, FileText, SignOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import PdfManager from "@/components/admin/PdfManager";
import LessonManager from "@/components/admin/LessonManager";

const AdminDashboard = ({ onLogout }) => {
  const [tab, setTab] = useState("pdfs");

  return (
    <div className="min-h-screen bg-slate-50">
      <nav className="sticky top-0 z-40 bg-white border-b-2 border-foreground">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <BookOpenText size={28} weight="duotone" className="text-primary" />
            <span className="font-fredoka font-bold text-lg text-foreground">Admin Console</span>
          </div>
          <Button
            variant="outline"
            onClick={onLogout}
            className="font-nunito border-2 border-foreground rounded-full"
            data-testid="admin-logout-btn"
          >
            <SignOut size={18} weight="bold" className="mr-2" />
            Logout
          </Button>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex gap-2 mb-6 border-b-2 border-foreground/10">
          <TabBtn active={tab === "pdfs"} onClick={() => setTab("pdfs")} testid="admin-tab-pdfs">
            <FilePdf size={18} weight="duotone" className="mr-2" />
            PDF Vault
          </TabBtn>
          <TabBtn active={tab === "lessons"} onClick={() => setTab("lessons")} testid="admin-tab-lessons">
            <FileText size={18} weight="duotone" className="mr-2" />
            Lesson Content
          </TabBtn>
        </div>

        {tab === "pdfs" && <PdfManager />}
        {tab === "lessons" && <LessonManager />}
      </div>
    </div>
  );
};

const TabBtn = ({ active, onClick, children, testid }) => (
  <button
    onClick={onClick}
    data-testid={testid}
    className={`px-5 py-3 font-nunito font-bold flex items-center border-b-4 transition-colors ${
      active
        ? "border-primary text-primary"
        : "border-transparent text-muted-foreground hover:text-foreground"
    }`}
  >
    {children}
  </button>
);

export default AdminDashboard;
